/**
 * O link de uso único do pedido na hora — spec 0071 (DD-05, FR-014, FR-015).
 *
 * Abre em `/familia/p/<token>`, direto do WhatsApp, sem a página da família. O
 * token vai à API no header `x-pedido-token` e vale até o pedido expirar.
 */

import React, { useEffect, useMemo, useState } from 'react';
import './PaginaFamilia.css';
import { Casca, ErroDaPagina, criarChamada } from './familia-comum';
import { DecisaoDoPedido, type PedidoDaFamilia } from './pedido-na-hora';

const PaginaPedido: React.FC<{ token: string }> = ({ token }) => {
  const chamar = useMemo(() => criarChamada('/api/familia-pedido', { 'x-pedido-token': token }), [token]);
  const [pedido, setPedido] = useState<PedidoDaFamilia | null>(null);
  const [falha, setFalha] = useState<{ invalido: boolean; texto: string } | null>(null);

  useEffect(() => { document.title = 'Pedido do motorista · Coopertransmig'; }, []);

  useEffect(() => {
    chamar<PedidoDaFamilia>('')
      .then(setPedido)
      .catch((e) => setFalha({ invalido: e instanceof ErroDaPagina && e.codigo === 'LINK_INVALIDO', texto: (e as Error).message }));
  }, [chamar]);

  if (falha) {
    return (
      <Casca>
        <h1 className="fam-titulo">{falha.invalido ? 'Este link não vale mais' : 'Não foi possível abrir'}</h1>
        <p className="fam-apoio">
          {falha.invalido
            ? 'O link do pedido vale só enquanto o pedido espera resposta. Se ele expirou, vale a regra de sempre, e o motorista já sabe.'
            : falha.texto}
        </p>
      </Casca>
    );
  }
  if (!pedido) return <Casca><p className="fam-apoio" role="status">Carregando…</p></Casca>;

  return (
    <Casca>
      <DecisaoDoPedido pedido={pedido} nivelTitulo="h1"
        decidir={(autoriza) => chamar<{ status: string }>('/decidir', { method: 'POST', body: JSON.stringify({ autoriza }) })} />
    </Casca>
  );
};

export default PaginaPedido;
